var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65.5,
    height: 65.5,
    viewBox: "0 0 65.5 65.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Orders_Icon",
    "data-name": "Orders Icon",
    transform: "translate(-17.594 -19.655)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_69",
    "data-name": "Ellipse 69",
    cx: 32,
    cy: 32,
    r: 32,
    transform: "translate(18.344 20.405)",
    fill: "#fff",
    stroke: "#cacaca",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2681",
    "data-name": "Group 2681",
    transform: "translate(31.274 31.864)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1491",
    "data-name": "Path 1491",
    d: "M77.5,74.208a1.137,1.137,0,0,0-.335-.833c-1.359-1.459-2.708-2.923-4.062-4.387a18.832,18.832,0,1,0-4.976,5q2.964,3.251,5.933,6.5a1.072,1.072,0,0,0,1.459.077c.565-.507,1.124-1.024,1.7-1.526a.754.754,0,0,0,.282-.622c-.01-1.407-.014-2.813,0-4.22Zm-8.21-23.674H47.037a2.481,2.481,0,0,0-.493.062.571.571,0,0,0-.483.6c0,.488-.01.981,0,1.469q0,8.052.014,16.1c0,.153-.019.306-.033.545a14.638,14.638,0,0,1-3.014-4.407,15.43,15.43,0,0,1-1-9.952,15.832,15.832,0,1,1,30.358,8.789,13.817,13.817,0,0,1-2.048,3.842c-.033-.014-.067-.029-.1-.043V51.476c0-.732-.215-.947-.947-.947Zm-21.98,1.622c0-.278.062-.378.364-.373,3.493.01,6.985,0,10.483,0H68.572a.359.359,0,0,1,.407.407q0,8.318,0,16.631a.982.982,0,0,1-.321.77,15.989,15.989,0,0,1-19.5,2.254c-.526-.316-1-.708-1.517-1.048a.73.73,0,0,1-.344-.7c.014-2.062.01-4.124.01-6.191q0-5.878,0-11.756Z",
    transform: "translate(-38.76 -39.74)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1492",
    "data-name": "Path 1492",
    d: "M64.256,99.466c-1.043,0-2.086.01-3.129,0a.681.681,0,0,1-.7-.919.7.7,0,0,1,.584-.459,6.027,6.027,0,0,1,.718-.048h5.163a4.949,4.949,0,0,1,.593.043.707.707,0,0,1,.684.742.689.689,0,0,1-.718.641c-.344.019-.689,0-1.033,0Z",
    transform: "translate(-50.032 -70.146)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1493",
    "data-name": "Path 1493",
    d: "M85.834,99.461h-3a.75.75,0,0,1-.794-.675.731.731,0,0,1,.722-.713c.383-.033.77-.043,1.153-.043h4.5a5.425,5.425,0,0,1,.622.038.7.7,0,0,1,.689.737.7.7,0,0,1-.737.655c-.646.014-1.292,0-1.938,0h-1.22Z",
    transform: "translate(-61.332 -70.141)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1494",
    "data-name": "Path 1494",
    d: "M64.283,92.448c-1.062,0-2.124.01-3.187,0a.67.67,0,0,1-.689-.746c.029-.373.354-.622.837-.622H67.12a2.43,2.43,0,0,1,.526.057.662.662,0,0,1-.077,1.311c-.531.029-1.062.029-1.593.033H64.287v-.024Z",
    transform: "translate(-50.049 -66.516)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1495",
    "data-name": "Path 1495",
    d: "M85.88,92.426c-1.043,0-2.081.014-3.124,0a.664.664,0,0,1-.589-1.043.947.947,0,0,1,.627-.316c.675-.043,1.354-.019,2.029-.019h3.813a3.853,3.853,0,0,1,.407.014.673.673,0,0,1,.684.732.626.626,0,0,1-.694.641c-1.053.014-2.105,0-3.153,0h0Z",
    transform: "translate(-61.33 -66.493)",
    fill: "#a5551c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1496",
    "data-name": "Path 1496",
    d: "M77.585,69.36H60.533c-.641,0-.7.057-.7.651q0,3.531,0,7.067c0,.66.029.679.684.679h8.54v.014h8.727c.55,0,.67-.12.67-.684V70.24c0-.837-.043-.88-.876-.88Z",
    transform: "translate(-49.749 -55.188)",
    fill: "#a5551c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1497",
    "data-name": "Path 1497",
    d: "M65.186,74.11a1.758,1.758,0,0,1,.694.134,1.627,1.627,0,0,1,.919.919,1.863,1.863,0,0,1,0,1.388,1.72,1.72,0,0,1-.364.555,1.645,1.645,0,0,1-.555.364,1.847,1.847,0,0,1-.694.134,1.808,1.808,0,0,1-.89-.225,1.643,1.643,0,0,1-.627-.627,1.858,1.858,0,0,1,0-1.789,1.611,1.611,0,0,1,.627-.627A1.758,1.758,0,0,1,65.186,74.11Zm.641,1.072a.839.839,0,0,0-.641-.268.848.848,0,0,0-.641.268,1.016,1.016,0,0,0,0,1.354.838.838,0,0,0,.641.268.848.848,0,0,0,.641-.268.959.959,0,0,0,.258-.679A.928.928,0,0,0,65.827,75.182Z",
    transform: "translate(-20.352 -25.802)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1498",
    "data-name": "Path 1498",
    d: "M74.3,77.6h-1l-.718-1.254h-.278V77.6H71.49V74.2h1.335a1.059,1.059,0,0,1,.536.144,1.09,1.09,0,0,1,.4.392,1.023,1.023,0,0,1,.153.536,1.127,1.127,0,0,1-.129.55,1.008,1.008,0,0,1-.359.378l.876,1.4Zm-1.99-2.608v.651h.421a.368.368,0,0,0,.249-.1.306.306,0,0,0,.105-.23.3.3,0,0,0-.1-.23.359.359,0,0,0-.249-.1h-.421Z",
    transform: "translate(-24.554 -25.849)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1499",
    "data-name": "Path 1499",
    d: "M78.971,74.195a1.774,1.774,0,0,1,.885.22,1.616,1.616,0,0,1,.627.6,1.642,1.642,0,0,1,.225.861,1.785,1.785,0,0,1-.225.88,1.576,1.576,0,0,1-.627.612,1.774,1.774,0,0,1-.885.22h-1.2v-3.4h1.2Zm.057,2.612a.76.76,0,0,0,.6-.263.958.958,0,0,0,.234-.665.9.9,0,0,0-.234-.646.771.771,0,0,0-.6-.254h-.435v1.828h.435Z",
    transform: "translate(-27.832 -25.844)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1500",
    "data-name": "Path 1500",
    d: "M84.66,74.2H86.8v.789H85.488v.488H86.66v.789H85.488v.55H86.8v.789H84.66V74.2Z",
    transform: "translate(-31.428 -25.849)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1501",
    "data-name": "Path 1501",
    d: "M92.733,77.6h-1l-.718-1.254h-.277V77.6H89.92V74.2h1.335a1.059,1.059,0,0,1,.536.144,1.09,1.09,0,0,1,.4.392,1.023,1.023,0,0,1,.153.536,1.127,1.127,0,0,1-.129.55,1.008,1.008,0,0,1-.359.378l.876,1.4Zm-1.99-2.608v.651h.421a.368.368,0,0,0,.249-.1.306.306,0,0,0,.105-.23.3.3,0,0,0-.1-.23.359.359,0,0,0-.249-.1h-.421Z",
    transform: "translate(-34.175 -25.849)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/Orders.9a3b3182a9cc37dba0c8e2c1f1b71a67.svg";
export { ForwardRef as ReactComponent };